/* Cookie Cartel: supports Shopify theme editor dynamic section re-renders. */
(function(){
  // Normalize CTA arrows page-wide, including text saved before the SVG update.
  // Only target this landing page; do not modify the Shopify theme navigation.
  function fixButtonArrows(root){
    const glyphs = /[↗↖↘↙↑↓➡⬆⬇⤴⤵➚➘\uFE0E\uFE0F]/gu;
    root.querySelectorAll('.cc-bulk .cc-button, .cc-bulk .cc-link').forEach(function(control){
      if(control.dataset.ccArrowsFixed === '1') return;
      let down = !!control.querySelector('.cc-arrow-down');
      let hadGlyph = false;
      Array.from(control.childNodes).forEach(function(node){
        if(node.nodeType !== 3) return;
        if(/[↓⬇]/u.test(node.nodeValue)) down = true;
        const clean = node.nodeValue.replace(glyphs, '');
        if(clean !== node.nodeValue){hadGlyph=true;node.nodeValue=clean;}
      });
      const existing = control.querySelector('.cc-arrow-up-right, .cc-arrow-down');
      if(!existing && (hadGlyph || control.matches('.cc-button, .cc-link'))){
        const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
        svg.setAttribute('viewBox','0 0 24 24');
        svg.setAttribute('aria-hidden','true');
        svg.setAttribute('focusable','false');
        svg.setAttribute('class',down ? 'cc-arrow-down' : 'cc-arrow-up-right');
        const path = document.createElementNS('http://www.w3.org/2000/svg','path');
        path.setAttribute('d',down ? 'M12 4v16m-7-7 7 7 7-7' : 'M5 19 19 5M8 5h11v11');
        svg.appendChild(path);control.appendChild(svg);
      }
      control.dataset.ccArrowsFixed='1';
    });
  }
  function setup(root){
    if(!root)root=document;
    fixButtonArrows(root);
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer=('IntersectionObserver' in window) ? new IntersectionObserver(function(items){items.forEach(function(item){if(item.isIntersecting){item.target.classList.add('cc-shown');observer.unobserve(item.target)}})},{threshold:.06}):null;
    root.querySelectorAll('.cc-bulk .cc-reveal:not([data-cc-initialized])').forEach(function(el){el.dataset.ccInitialized='1';if(observer&&!reduce){observer.observe(el)}else{el.classList.add('cc-shown')}});
    root.querySelectorAll('[data-cc-swipe]:not([data-cc-initialized])').forEach(function(carousel){
      carousel.dataset.ccInitialized='1';const track=carousel.querySelector('.cc-swipe__track');const children=[...track.children];const dots=carousel.querySelector('.cc-swipe__dots');
      children.forEach(function(child,index){const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label','View card '+(index+1));dot.addEventListener('click',function(){child.scrollIntoView({behavior:reduce?'instant':'smooth',inline:'start',block:'nearest'})});dots.appendChild(dot)});
      function update(){if(window.innerWidth>749)return;const nearest=children.reduce((a,el,index)=>Math.abs(el.offsetLeft-track.offsetLeft-track.scrollLeft)<Math.abs(children[a].offsetLeft-track.offsetLeft-track.scrollLeft)?index:a,0);[...dots.children].forEach(function(d,i){d.classList.toggle('is-active',i===nearest)})}
      track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
    });
    root.querySelectorAll('[data-cc-gif-interval]:not([data-cc-initialized])').forEach(function(section){
      section.dataset.ccInitialized='1';const frames=[...section.querySelectorAll('.cc-motion__frame')];const counter=section.querySelector('.cc-motion__counter');if(!frames.length)return;let i=0;let visible=false;const format=n=>String(n).padStart(2,'0');function show(){frames.forEach((el,n)=>el.classList.toggle('is-active',n===i));if(counter)counter.textContent=format(i+1)+' / '+format(frames.length)}show();
      if(reduce||frames.length<2)return;
      if('IntersectionObserver' in window){const watch=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting},{threshold:.1});watch.observe(section)}else visible=true;
      setInterval(function(){if(!visible||document.hidden)return;i=(i+1)%frames.length;show()},Math.max(3,Number(section.dataset.ccGifInterval)||6)*1000);
    });
    root.querySelectorAll('.cc-bulk video').forEach(function(video){if(video.dataset.ccVideo)return;video.dataset.ccVideo='1';if(reduce){video.pause();return}if('IntersectionObserver' in window){const watch=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){video.play().catch(()=>{})}else{video.pause()}},{threshold:.1});watch.observe(video)}});
    // A successful Shopify POST rerenders the page; clear the contact form once success is shown.
    root.querySelectorAll('.cc-bulk form:has([data-cc-form-success])').forEach(function(form){
      form.reset();
      form.querySelectorAll('input:not([type=hidden]), textarea').forEach(function(field){
        if(field.type!=='checkbox' && field.type!=='radio')field.value='';
      });
      form.querySelectorAll('select').forEach(function(select){select.selectedIndex=0;});
      // Ensure previously entered values are not restored on browser refresh.
      form.setAttribute('autocomplete','off');
    });
    root.querySelectorAll('.cc-bulk .cc-field input[type=date]').forEach(el=>{const now=new Date();const local=new Date(now.getTime()-now.getTimezoneOffset()*60000).toISOString().slice(0,10);el.min=local});
  }

  // All bulk quotation anchors point to this single form on the page.
  // Delegation also handles sections re-rendered by the Shopify Theme Editor.
  document.addEventListener('click',function(event){
    const link=event.target.closest('a[href]');
    if(!link || !link.closest('.cc-bulk'))return;
    const href=link.getAttribute('href');
    if(href !== '#cc-enquire' && href !== '#cc-lineup')return;
    const target=document.getElementById(href.substring(1));
    if(!target)return;
    event.preventDefault();
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
    if(window.history && window.history.replaceState){
      window.history.replaceState(null,'',window.location.pathname+window.location.search+href);
    }
  });
  function init(){if(document.querySelector('.cc-bulk')){document.body.classList.add('cc-bulk-page');setup(document)}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(e){setup(e.target)});
})();
